import { render, staticRenderFns } from "./studioDashboardDaycare.vue?vue&type=template&id=02a4bbe5&scoped=true"
import script from "./studioDashboardDaycare.vue?vue&type=script&lang=js"
export * from "./studioDashboardDaycare.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardDaycare.vue?vue&type=style&index=0&id=02a4bbe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a4bbe5",
  null
  
)

export default component.exports